import pdfMake from "pdfmake/build/pdfmake";

export const generatePdf = ({
    content = [],
    images = [],
    logo,
    pageOrientation = "portrait",
    pageSize = "A4",
    styles = {}
}) => {
    const pdfDefinition = {
        pageSize,
        pageOrientation,

        images: logo ? { logo } : {},

        content: [
            ...(logo ? [{
                columns: [
                    { text: "" },
                    {
                        image: "logo",
                        width: 100,
                        alignment: "right"
                    }
                ],
                margin: [0, 0, 0, 20]
            }] : []),

            ...content,

            ...images.map(img => ({
                image: img,
                width: 520,
                margin: [0, 0, 0, 10]
            }))
        ],

        styles
    };

    pdfMake.createPdf(pdfDefinition).open();
};